export default "__VITE_ASSET__BbF7SFZc__"